import styled from 'styled-components';

import { getColor } from '@utils/theme';

import { ColorTypes, FontSizeTypes, TintTypes } from '@folx-types/theme';

import theme from '@theme/WsTheme';

type IEyebrowProps = {
	color?: ColorTypes;
	tint?: TintTypes;
	size?: FontSizeTypes;
	variant?: 'body' | 'header';
	weight?: 'normal' | 'bold';
	underline?: boolean;
};

export default styled.p<IEyebrowProps>`
	font-family: 'Chalet', sans-serif;
	font-size: ${({ variant = 'body', size = 'sm' }) => theme.fontSizes[variant][size]};
	font-family: ${({ size }) => {
		if (size === 'label') return 'Montserrat';
	}};
	letter-spacing: 0;
	color: ${({ color = 'black', tint }) => getColor(color, tint)};
	font-weight: ${({ weight = 'bold' }) => weight};
	font-weight: ${({ size }) => {
		if (size === 'label') return 'normal';
	}};
	border-bottom: ${({ color = 'black', tint, underline, weight = 'bold' }) =>
		underline && `${weight === 'bold' ? 0.3 : 0.1}rem solid ${getColor(color, tint)}`};
`;
